import * as React from 'react';
import {Container} from '../grid/container';
import {Translation} from "../../lang";

const alignRight: any = {
    textAlign: 'right'
};

export class IntroductionComponent extends React.Component<any, any> {
    render() {
        return <Container className="homeComponent">

            <div className="row">
                <div className="col-12 col-sm-10 offset-sm-1">

                    <div className="col-12 flex-wrap d-flex align-items-center flex-column-reverse flex-lg-row">

                        <div className="col-12 col-lg-6 d-inline-block animated fadeInRight content-height">
                            <img width="100%" src="/assets/src/components/introduction/ceo.png" alt=""/>
                        </div>

                        <div
                            className="col-12 col-lg-6 d-inline-block fst-italic animated content-height fadeInLeft text-center text-lg-right pt-5"
                            style={alignRight}>
                            <br className="d-block d-sm-none"/>

                            <h1 className="text-white MS fw-bold">{Translation.get('introduction.title')}</h1>
                            <p className="MS text-white" style={{whiteSpace: 'pre-wrap'}}>
                                {Translation.get('introduction.description')}
                            </p>
                        </div>
                    </div>

                </div>
            </div>

        </Container>;
    }
}
